(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lps-article"] && !Shopify.designMode) return;
  try {
    
function initReadingArticle(root){if(root.dataset.readingReady)return;root.dataset.readingReady='true';const bar=root.querySelector('[data-reading-progress]');let pending=false;const update=()=>{const rect=root.getBoundingClientRect();const available=Math.max(1,rect.height-innerHeight);const progress=Math.max(0,Math.min(1,-rect.top/available));bar.style.transform=`scaleX(${progress})`;pending=false};const schedule=()=>{if(!pending){pending=true;requestAnimationFrame(update)}};addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule);update()}
document.querySelectorAll('[data-reading-article]').forEach(initReadingArticle);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-reading-article]').forEach(initReadingArticle));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lps-journal"] && !Shopify.designMode) return;
  try {
    
function initJournal(root){if(root.dataset.ready)return;root.dataset.ready='true';const motion=root.querySelector('[data-motion]');motion.hidden=false;motion.addEventListener('click',()=>{const paused=root.dataset.paused!=='true';root.dataset.paused=String(paused);motion.textContent=paused?motion.dataset.resume:motion.dataset.pause});const filters=root.querySelector('[data-filters]');if(filters){filters.hidden=false;filters.addEventListener('click',event=>{const button=event.target.closest('[data-topic]');if(!button)return;filters.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));root.querySelectorAll('[data-topic-section]').forEach(group=>{group.hidden=button.dataset.topic!=='all'&&group.dataset.topicSection!==button.dataset.topic})})}}
document.querySelectorAll('[data-journal]').forEach(initJournal);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-journal]').forEach(initJournal));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
